import { render, staticRenderFns } from "./vipDetailIntegral.vue?vue&type=template&id=14430ccc&scoped=true"
import script from "./vipDetailIntegral.vue?vue&type=script&lang=js"
export * from "./vipDetailIntegral.vue?vue&type=script&lang=js"
import style0 from "./vipDetailIntegral.vue?vue&type=style&index=0&id=14430ccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14430ccc",
  null
  
)

export default component.exports